import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/categories/${id}`)
    },
    list(params) {
        return Vue.axios.get(`/categories`, {params})
    },
    update(id, data) {
        return Vue.axios.post(`/categories/update/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    updateModifierRelation(itemId, params){
        return Vue.axios.post(`/categories/update/modifiers/${itemId}`, params)
    },
    remove(id) {
        return Vue.axios.get(`/categories/remove/${id}`)
    },
    create(data) {
        return Vue.axios.post(`/categories/create`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    listWithChildren(params) {
        return Vue.axios.get(`/categories/with-children`)
    },
    updateModifiersGroup(id, data) {
        return Vue.axios.post(`/categories/update/${id}/modifiers-group`, data)
    },
    saveTagSort(params) {
        return Vue.axios.post(`/category-tag-sorts`, params)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
